// NOTE: This file is a copy of the report type definitions from
// apps/client/src/modules/reports/shared/reportTypes.ts (IDs and titles only).
// If you add or remove a report type, update both files to keep them in sync.

export interface AdminReportType {
	id: string
	title: string
}

export const REPORT_TYPES: Record<string, AdminReportType[]> = {
	'Overall Cycle Status Reports': [
		{ id: 'overall-status', title: 'Overall Status' },
		{ id: 'status-by-reviewer', title: 'Status by Reviewer' },
	],
	'Full Evaluation Reports': [{ id: 'full-evaluation-report', title: 'Full Evaluation Report' }],
	'Incomplete Status Reports': [
		{ id: 'not-submitted-all', title: 'Not Submitted - All' },
		{ id: 'not-submitted-employee', title: 'Not Submitted - Employee' },
		{ id: 'not-submitted-manager', title: 'Not Submitted - Manager' },
	],
	'Status Aggregate Reports': [
		{ id: 'individual-by-department', title: 'Individual Status by Department' },
		{ id: 'individual-by-title', title: 'Individual Status by Title' },
		{ id: 'individual-by-location', title: 'Individual Status by Location' },
	],
	Ratings: [
		{ id: 'pec-ratings', title: 'PEC Ratings' },
		{ id: 'all-ratings', title: 'All Ratings' },
		{ id: 'competency-ratings-manager', title: 'Competency Ratings - Manager' },
		{ id: 'overall-ratings-manager', title: 'Overall Ratings - Manager' },
		{ id: 'individual-competency-ratings', title: 'Individual Competency Ratings' },
	],
	Comments: [
		{ id: 'all-comments', title: 'All Comments' },
		{ id: 'flagged-words', title: 'Flagged Words' },
	],
	'Distributions & Comparisons': [
		{ id: 'competency-average-ratings', title: 'Competency Average Ratings' },
		{ id: 'overall-rating-comparison-department', title: 'Overall Rating - Comparison by Department' },
		{ id: 'overall-rating-comparison-title', title: 'Overall Rating - Comparison by Title' },
		{ id: 'overall-rating-comparison-location', title: 'Overall Rating - Comparison by Location' },
		{
			id: 'avg-competency-ratings-comparison-department',
			title: 'Average Competency Ratings - Comparison by Department',
		},
		{ id: 'avg-competency-ratings-comparison-title', title: 'Average Competency Ratings - Comparison by Title' },
		{
			id: 'avg-competency-ratings-comparison-location',
			title: 'Average Competency Ratings - Comparison by Location',
		},
	],
}
